import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { TimeConstants } from '../../../constants/time';
import { handleError } from '../../../utils/common';
import { useAlertModal } from '../../../utils/hook/hook';
import type { BenefitEligibilityRes } from '../dto/response/app-onboarding-benefit.res.dto';
import { UserApi } from '../user.api';

/**
 * 마케팅 최초동의 혜택 팝업 노출 여부 조회 훅 (마케팅 동의 팝업 게이트).
 * 호출 조건(앱 웹뷰·로그인 등)은 options.enabled로 제어한다.
 */
const useMarketingConsentBenefitEligibilityQuery = (
  options?: Omit<
    UseQueryOptions<BenefitEligibilityRes>,
    'queryKey' | 'queryFn' | 'meta'
  >,
) => {
  const { openAlertModal } = useAlertModal();

  const queryResult = useQuery({
    queryKey: UserApi.queryKeys.getMarketingConsentBenefitEligibility(),
    queryFn: () => UserApi.getMarketingConsentBenefitEligibility(),
    staleTime: TimeConstants.FIVE_MINUTES,
    meta: {
      onError: (error: unknown) =>
        handleError(openAlertModal, error, '마케팅 동의 혜택 노출 여부 확인'),
    },
    ...options,
  });

  return { ...queryResult, eligible: queryResult.data?.eligible ?? false };
};

export default useMarketingConsentBenefitEligibilityQuery;
